/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import type { RootState } from '../types/types';
import { deleteSeedList, getAllSeedListByClientId } from 'src/services/seedListService';
import GradientButton from '../MUICustomButton/GradientButton';
import { Grid, IconButton, Menu, MenuItem } from '@mui/material';
import { checkEventPermission } from 'src/common/utility/utility';
import CustomDataTable from '../CustomDataTable/CustomDataTable';
import moment from 'moment';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import { PencilEdit02Icon } from '@hugeicons-pro/core-stroke-rounded';
//@ts-ignore
import { MoreVerticalSolidRounded } from '@hugeicons-pro/core-solid-rounded';
//@ts-ignore
import {MultiplicationSignStrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import MUIModal from '../MUIModal/MUIModal';
import AddSeedList from './AddSeedList';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import OutlineButton from '../MUICustomButton/OutlineButton';
import { ARE_YOU_SURE, DELETE_SEED_LIST } from 'src/constants/constant';
import EditSeedList from './EditSeedList';
import { NotificationManager } from 'react-notifications';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;

interface SeedListPropType {
    seedList: any;
    seedListData: any[];
}

interface ApiResponse {
    status: number;
    data: {
        data: SeedListPropType[];
        result: number;
    };
}

function SeedList(): JSX.Element {

    const { user } = useSelector((state: RootState) => state.auth);

    const [seedList, setSeedList] = React.useState<any[]>([]);
    const [seedListSearchData, setSeedListSearchData] = React.useState<any[]>([]);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [addListModalOpen, setAddListModalOpen] = React.useState<boolean>(false);
    const [anchorActionEl, setAnchorActionEl] = React.useState<any>({});
    const [openDeleteModal, setOpenDeleteModal] = React.useState<boolean>(false);
    const [seedInfoData, setSeedInfoData] = React.useState<any>();
    const [isModalSaveLoading, setIsModalSaveLoading] = React.useState<boolean>(false);
    const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
    const [seedListId, setSeedListId] = React.useState<any>();

    useEffect(() => {
        getSeedListData();
    }, [user]);

    const getSeedListData = (): void => {
        setLoading(true);
        const ClientId = user?.clientId ?? 0;
        getAllSeedListByClientId(ClientId).then((response: ApiResponse) => {
            if (response.status === 200) {
                if (response.status === 200) {
                    if (response.data.result === 1) {
                        // setSeedList(response.data.data);
                        const data: any = response.data.data;
                        let seedListData: any[] = [];
                        if (data && data.length > 0) {
                            data.map((item: SeedListPropType) => {
                                item.seedList.count = item.seedListData.length;
                                seedListData.push(item.seedList);
                            });
                        }

                        setSeedList(seedListData);
                        setSeedListSearchData(seedListData);
                    }

                }
            } else {
                console.error("Failed to fetch seed list data");
            }
        }).catch((error) => {
            console.error("Error fetching seed list data:", error);
        })
            .finally(() => {
                setLoading(false);
            });
    }

    const handleRefreshPage = (): void => {
        setAddListModalOpen(false)
        setOpenEditModal(false);
        setSeedListId(null);
        getSeedListData()
    }

    const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
            const { value } = event.target;
        let seedListArr = [...seedList]
        if (value !== "") {
            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions, @typescript-eslint/prefer-optional-chain
            seedListArr = seedListArr && seedListArr.filter((seed: any) => {
                return seed.title.toLowerCase().search(value.toLowerCase()) >= 0
            })
        }
        setSeedListSearchData(seedListArr)
    }

    const handleAddListlick = (): void => {
        // Logic to open modal or navigate to add seed list page
        setAddListModalOpen(true);
    };

    const handleActionClick = (event: React.MouseEvent<HTMLElement>, id: number): void => {
        // anchorActionEl[id] = event.currentTarget
        setAnchorActionEl({ ...anchorActionEl, [id]: event.currentTarget });
    }

    const handleDeleteSeed = (id: number, title: string): void => {
        setSeedInfoData({ id, title });
        setOpenDeleteModal(true)
        setAnchorActionEl(null);
        setAnchorActionEl({ ...anchorActionEl, [id]: null });
    }

    const handleDeleteListClose = (): void => {
        setOpenDeleteModal(false);
        setSeedInfoData(null);
    }

    const handleDeleteSeedListConfirm = (): void => {
        if (seedInfoData) {
            setIsModalSaveLoading(true);
            const modifiedById = user?.id ?? 0;
            deleteSeedList(seedInfoData.id, modifiedById).then((response: any) => {
                if (response.status === 200) {
                    NotificationManager.success('Seed List deleted successfully');
                    getSeedListData();
                }
            }).catch((error: any) => {
                console.error("Error deleting Seed List:", error);
                NotificationManager.error('Error deleting Seed List');
            }).finally(() => {
                setIsModalSaveLoading(false);
                setOpenDeleteModal(false);
                setSeedInfoData(null);
            });
            
        }
        
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleEditSeedClick = (id: number): void => {
        setSeedListId(id);
        setOpenEditModal(true);
    }

    // const handleEditSeedClose = (): void => {
    //     setOpenEditModal(false);
    // }

    const columns = [
        {
            name: 'Title',
            selector: (row: any) => row.title,
            sortable: true,
            width: '30%',
        },
        {
            name: 'No of Seeds',
            selector: (row: any) => row.count,
            sortable: true,
            width: '30%',
            center: true,
        },
        {
            name: 'Created',
            selector: (row: any) => moment(row.createdOn).format("MM/DD/YYYY"),
            sortable: true,
            width: '20%',
        },
        {
            name: 'Actions',
            cell: (row: any) => {
                return (
                    <div className='flex items-center'>
                        <div className="icon-hover-container" onClick={() => handleEditSeedClick(row.id)}>
                            {/* <Link to={{ pathname: `/campaigns/edit-campaign/${row.campaignId}` }} state={{ campaigndata: row }} style={{ width: '20px' }}> */}
                            {/* <img src={'/assets/images/icons/EditIcon.svg'} width={20} height={20} alt="Edit Campaign" className="icon-hover" /> */}
                            <HugeiconsIcon
                                icon={PencilEdit02Icon}
                                size={20}
                                color="#3A3A3A"
                                strokeWidth={0.2}
                            />
                            {/* </Link> */}
                        </div>
                    {checkEventPermission("SEEDLIST_DELETE") && 
                        <div className='flex'>
                            <IconButton
                                aria-label="more"
                                id="long-button"
                                // aria-controls={open ? 'long-menu' : undefined}
                                // aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={(e) => handleActionClick(e, row.id)}
                            >
                                <HugeiconsIcon
                                    icon={MoreVerticalSolidRounded}
                                    size={20}
                                    color="#3A3A3A"
                                    strokeWidth={0.2}
                                />
                            </IconButton>
                            <Menu
                                id={`${row.id}`}
                                className='table-action-menu'
                                MenuListProps={{
                                    'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorActionEl[row.id]}
                                open={Boolean(anchorActionEl[row.id])}
                                onClose={() => setAnchorActionEl({ ...anchorActionEl, [row.id]: null })}
                               slotProps={{ paper: {
                                    style: {
                                        maxHeight: ITEM_HEIGHT * 4.5,
                                        width: '18ch',
                                    },
                                }}}
                            >


                                <MenuItem onClick={() => handleDeleteSeed(row.id, row.title)}>
                                    <span style={{ paddingLeft: '15px', cursor: row.isBrandInUse !== true ? 'pointer' : 'not-allowed', color: row.isBrandInUse === true ? '#A0A0A0' : '#F13139' }}>Delete</span>
                                </MenuItem>
                            </Menu>
                        </div>
                        }
                    </div>
                )
            },
            width: '15%',
            center: true,
        }
    ];

    return (

                <>
                    <h2 className="text-2xl font-semibold text-title">Seed List</h2>
                    <div className="mt-[20px] mb-[20px] live-outreach-container">
                        <Grid container spacing={2} alignItems={'center'}>
                            <Grid item xs={12} sm={6} md={6} lg={4}>
                                <div className="w-full">
                                    <input
                                        type="text"
                                        placeholder="Search by title"
                                        className="input input-bordered search-input-white focus:ring-0 focus:outline-none border-[#E6ECF2] font-normal text-14 text-muted w-full"
                                        onChange={handleSearch}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={6} md={6} lg={8} className='bulk-action flex justify-end'>
                                {checkEventPermission("SEEDLIST_ADD") &&
                                    <GradientButton color='red' onClick={handleAddListlick}>
                                        <span style={{
                                            width: "20px",
                                            height: "20px",
                                            background: "#fff",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            borderRadius: "50px",
                                            marginRight: "5px"
                                        }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 19 19" fill="none">
                                                <path d="M17.5411 10.3185H1.03183C0.467764 10.3185 0 9.85078 0 9.28671C0 8.72265 0.467764 8.25488 1.03183 8.25488H17.5411C18.1052 8.25488 18.573 8.72265 18.573 9.28671C18.573 9.85078 18.1052 10.3185 17.5411 10.3185Z" fill="#F13139" />
                                                <path d="M9.28671 18.573C8.72265 18.573 8.25488 18.1052 8.25488 17.5411V1.03183C8.25488 0.467764 8.72265 0 9.28671 0C9.85078 0 10.3185 0.467764 10.3185 1.03183V17.5411C10.3185 18.1052 9.85078 18.573 9.28671 18.573Z" fill="#F13139" />
                                            </svg>
                                        </span>
                                        Add New Seed List
                                    </GradientButton>
                                }
                            </Grid>
                        </Grid>
                    </div>

                    <div className='data-table-container mb-10 te-table-container'>
                        <CustomDataTable
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            columns={columns}
                            data={seedListSearchData}
                            pagination
                            // selectableRows
                            progressPending={loading}
                        />
                    </div>

                    {/* Add Seed List */}
                    <MUIModal title='New Seed List' openModal={addListModalOpen} closeModal={() => setAddListModalOpen(false)} width={'50%'} >
                        <AddSeedList onClose={() => setAddListModalOpen(false)} onRefresh={handleRefreshPage} />
                    </MUIModal>

                    {/* Edit Seed List */}

                    <MUIModal title='Edit Seed List' openModal={openEditModal} closeModal={() => setOpenEditModal(false)} width={'50%'} >
                        <EditSeedList seedListId={seedListId}  onClose={() => setOpenEditModal(false)} onRefresh={handleRefreshPage}/>
                    </MUIModal>

                    {/* Delete Seed List */}

                    <BootstrapDialog
                        onClose={handleDeleteListClose}
                        aria-labelledby="customized-dialog-title"
                        open={openDeleteModal}
                        PaperProps={{
                            sx: {
                                width: '550px',
                                height: '200px'
                            },
                        }}
                    >
                        <DialogTitle sx={{ m: 0, p: 2, color: '#3A3A3A', fontSize: '18px', fontWeight: '600' }} id="customized-dialog-title">
                            Delete Seed List
                        </DialogTitle>

                        <IconButton
                            aria-label="close"
                            onClick={handleDeleteListClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <HugeiconsIcon
                                icon={MultiplicationSignStrokeStandard}
                                size={24}
                                color="currentcolor"
                                strokeWidth={0.5}
                            />
                        </IconButton>
                        <DialogContent>
                            <p className='text-14 text-muted'>{ARE_YOU_SURE} {DELETE_SEED_LIST} <span className='font-semibold'>{seedInfoData?.title}</span>?</p>
                        </DialogContent>
                        <DialogActions sx={{ background: '#F9F9F9' }}>

                            <OutlineButton color='gray' onClick={handleDeleteListClose} width='100px'>Cancel</OutlineButton>

                            <GradientButton type='button' color='red' onClick={handleDeleteSeedListConfirm} width='100px'>{!isModalSaveLoading ? 'Delete' : <span className="loading loading-spinner loading-xs text-white"></span>}</GradientButton>
                        </DialogActions>
                    </BootstrapDialog>
                </>
    )
}

export default SeedList